'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaCartController = function () {
  function WinresOmalomaCartController($scope, $rootScope, reservationService) {
    _classCallCheck(this, WinresOmalomaCartController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.reservationService = reservationService;
    this.clear();
  }

  _createClass(WinresOmalomaCartController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$scope.$watchGroup([function () {
        return _this.productLines;
      }, function () {
        return _this.passengers;
      }], function () {
        return _this.update();
      });
    }
    //

  }, {
    key: 'clear',
    value: function clear() {
      this.$scope.rows = [];
    }
  }, {
    key: 'removeRow',
    value: function removeRow(row) {
      this.$rootScope.$broadcast('removerow', row);
    }
    //

  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      if (!this.productLines) {
        console.log('[WOC] No product lines yet. Cannot update.');
        return;
      } else if (!this.passengers) {
        console.log('[WOC] No passengers yet. Cannot update.');
        return;
      }

      var rows = _.map(this.productLines, function (line) {
        var product = _this2.relevantProducts[line.timeStamp][line.DestinationCode][line.ProductCode];
        console.log(_this2.relevantProducts);
        console.log("[WOC] product: ", product);
        console.log("[WOC] line: ", line);
        console.log("[WOC] passsengers", _this2.passengers);

        var mergedPassengers = _.map(line.PassengerAssignments, function (passenger) {
          return _.merge(passenger, _.find(_this2.passengers, { Number: passenger.PassengerNumber }));
        });

        return {
          amount: line.Amount,
          name: product.DestinationInfo.ProductName,
          beginDate: line.BeginDate,
          endDate: line.isAreaService ? '' : line.EndDate,
          prices: line.isAreaService ? line.PriceSelections : null,
          // priceLabels: _.map(line.PriceSelections, priceSelection => priceSelection.PriceLabel),
          price: null, // Fetched asynchronously below
          assignedPassengers: mergedPassengers,
          destinationCode: product.DestinationInfo.DestinationCode,
          productCode: product.DestinationInfo.ProductCode,
          timeStamp: line.timeStamp
        };
      });

      this.$scope.accommodationRows = _.filter(rows, function (row) {
        return !row.prices;
      });

      // Create area service rows from area service price selections
      var areaRows = _.filter(rows, function (row) {
        return row.prices;
      });
      var priceRows = [];
      _.each(areaRows, function (areaRow) {
        _.each(areaRow.prices, function (price, idx) {
          var row = _.cloneDeep(areaRow);
          row.name += ", " + price.PriceLabel;
          row.price = price.Price * price.Amount;
          row.amount = price.Amount;
          row.priceIndex = price.PriceIndex;
          row.index = price.Index;
          priceRows.push(row);
        });
      });

      this.$scope.areaRows = priceRows;

      // console.log('[WOC] Updating prices.');

      var accommodationProductLines = _.filter(this.productLines, function (productLine) {
        return !productLine.isAreaService;
      });

      var q = this.reservationService.calculateProductLinePricesSimple(accommodationProductLines, this.passengers, 'fi');
      q.then(function (prices) {
        console.log('[WOC] Received prices:', prices);
        _.forEach(prices, function (price, i) {
          _this2.$scope.accommodationRows[i].price = price.Price;
        });
      }, function (error) {
        console.error('[WOC] Failed to receive prices:', error);
        _this2.clear();
      });
      updateCartPosition(); // Move cart upward if below footer. footer.php.
    }
  }]);

  return WinresOmalomaCartController;
}();

WinresOmalomaCartController.$inject = ['$scope', '$rootScope', 'reservationService'];

_module3.default.component('winresOmalomaCart', {
  template: require('./winresOmalomaCart.html'),
  controller: WinresOmalomaCartController,
  bindings: {
    relevantProducts: '<',
    productLines: '<',
    passengers: '<',
    removable: '@',
    onChange: '&'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaCart/winresOmalomaCart.js
// module id = 323
// module chunks = 2